import { z } from 'zod';

import { AccountIdSchema } from './account';

const NullableDecimalStringSchema = z.string().nullable();

export const TradingPortfolioHeatQuerySchema = z.object({
  accountId: AccountIdSchema,
});

export const TradingPortfolioHeatResponseSchema = z.object({
  status: z.enum(['COMPLETE', 'INCOMPLETE']),
  account: z.object({
    id: z.string().trim().min(1),
    name: z.string(),
    currency: z.string().trim().min(1),
  }),
  knownRiskAmount: z.string(),
  knownHeatPctNav: NullableDecimalStringSchema,
  nav: z.object({
    amount: NullableDecimalStringSchema,
    asOfDate: z.string().nullable(),
    createdAt: z.string().datetime().nullable(),
    stale: z.boolean().nullable(),
    usable: z.boolean(),
  }),
  budget: z.object({
    configured: z.boolean(),
    pctNav: NullableDecimalStringSchema,
    amount: NullableDecimalStringSchema,
  }),
  remainingBudget: z.object({
    pctNav: NullableDecimalStringSchema,
    amount: NullableDecimalStringSchema,
  }),
  knownRiskExceedsBudgetByAmount: NullableDecimalStringSchema,
  counts: z.object({
    openPositionCount: z.number().int().nonnegative(),
    calculatedPositionCount: z.number().int().nonnegative(),
    uncalculableOpenPositionCount: z.number().int().nonnegative(),
    missingStopCount: z.number().int().nonnegative(),
    unreliableStopCount: z.number().int().nonnegative(),
    historyIncompleteCount: z.number().int().nonnegative(),
    currencyMismatchCount: z.number().int().nonnegative(),
  }),
});

export type TradingPortfolioHeatResponse = z.infer<typeof TradingPortfolioHeatResponseSchema>;
